import { createAction, props } from '@ngrx/store';

import { ProjectElementsEntity } from '../components/project-delete-popup/project-elements.entity';
import { ProjectListEntity } from '../components/project-list/project-list.entity';
import { ProjectMemberEntity } from '../components/project-list/project-member.entity';

export enum ProjectActions {
	InitProjects = '[Project] get projects',
	OrphanProjectsCheck = '[Project] orphan projects check',
	OrphanProjectsCheckSuccess = '[BE][Project] orphan projects check success',
	OrphanProjectsCheckFail = '[BE][Project] orphan projects check failure',
	RefreshProjects = '[Project] refresh projects',
	FetchProjectsSuccess = '[BE][Project] fetch Projects success',
	FetchProjectsWithViewSettingsSuccess = '[BE][Project] fetch Projects, search term, view mode success',
	FetchProjectsFail = '[BE][Project] fetch Projects fail',
	NavigateToProjectRoute = '[Project] navigate to Project route',
	NavigateToProjectEditRoute = '[Project] navigate to Project edit route',
	SetDefaultProject = '[BE][Project] set default project',
	SetFavoriteProject = '[BE][Project] set favorite project',
	SwitchProjectsViewMode = '[Project] switch projects view mode',
	ModifySearchTerm = '[Project] modify search term',
	SendEmailToAdmin = '[BE][Project] send email to admin',
	GetProjectMembers = '[BE][Project] get project members',
	GetProjectMembersSuccess = '[BE][Project] get project members success',
	IsProjectDeletable = '[BE][Project] get is project deletable',
	FetchIsProjectDeletableSuccess = '[BE][Project] get is project deletable success',
	GetProjectCriticalAndElements = '[BE][Project] get project critical and dc elements',
	FetchProjectElementsSuccess = '[BE][Project] fetch project critical and dc elements success',
	SendVerificationCode = '[BE][Project] send verification code',
	DeleteProject = '[BE][Project] delete project',
	DeleteProjectSuccess = '[BE][Project] delete project success',
	DeleteProjectFail = '[BE][Project] delete project fail',
	ResetProject = '[Project] reset project',
	NavigateToOrphanProjectsRoute = '[Orphan Project] navigate to orphan projects route',
	NavigateToCreateProjectRoute = '[Project] navigate to new project route',
}

export const initProjects = createAction(ProjectActions.InitProjects);
export const refreshProjects = createAction(ProjectActions.RefreshProjects);
export const fetchProjectsSuccess = createAction(
	ProjectActions.FetchProjectsSuccess,
	props<{ projectList: ProjectListEntity }>()
);
export const fetchProjectsWithViewSettingsSuccess = createAction(
	ProjectActions.FetchProjectsWithViewSettingsSuccess,
	props<{
		projectList: ProjectListEntity;
		viewMode: string;
		term: string;
	}>()
);

export const fetchProjectsFail = createAction(
	ProjectActions.FetchProjectsFail,
	props<{ error: unknown }>()
);

export const orphanProjectsCheck = createAction(
	ProjectActions.OrphanProjectsCheck
);
export const orphanProjectsCheckSuccess = createAction(
	ProjectActions.OrphanProjectsCheckSuccess,
	props<{
		hasOrphanProjects: boolean;
	}>()
);

export const orphanProjectsCheckFail = createAction(
	ProjectActions.OrphanProjectsCheckFail,
	props<{ error: unknown }>()
);

export const navigateToProject = createAction(
	ProjectActions.NavigateToProjectRoute,
	props<{ id: number }>()
);
export const navigateToProjectEdit = createAction(
	ProjectActions.NavigateToProjectEditRoute,
	props<{ id: number }>()
);
export const setDefaultProject = createAction(
	ProjectActions.SetDefaultProject,
	props<{ id: number; isDefault: boolean }>()
);
export const setFavoriteProject = createAction(
	ProjectActions.SetFavoriteProject,
	props<{ id: number; isFavorite: boolean }>()
);
export const switchProjectsViewMode = createAction(
	ProjectActions.SwitchProjectsViewMode,
	props<{ viewMode: string }>()
);
export const modifySearchTerm = createAction(
	ProjectActions.ModifySearchTerm,
	props<{ term: string }>()
);

export const sendEmailToAdmin = createAction(
	ProjectActions.SendEmailToAdmin,
	props<{
		projectId: number;
		adminId: string;
		title: string;
		message: string;
	}>()
);

export const getProjectMembers = createAction(
	ProjectActions.GetProjectMembers,
	props<{ projectId: number }>()
);
export const getProjectMembersSuccess = createAction(
	ProjectActions.GetProjectMembersSuccess,
	props<{ projectId: number; members: Array<ProjectMemberEntity> }>()
);

export const isProjectDeletable = createAction(
	ProjectActions.IsProjectDeletable,
	props<{ id: number }>()
);

export const fetchIsProjectDeletableSuccess = createAction(
	ProjectActions.FetchIsProjectDeletableSuccess,
	props<{ id: number; isDeletable: boolean }>()
);

export const getProjectElements = createAction(
	ProjectActions.GetProjectCriticalAndElements,
	props<{ id: number }>()
);

export const fetchProjectElementsSuccess = createAction(
	ProjectActions.FetchProjectElementsSuccess,
	props<{ id: number; elements: ProjectElementsEntity; isCritical: boolean }>()
);

export const sendVerificationCode = createAction(
	ProjectActions.SendVerificationCode,
	props<{ id: number }>()
);

export const deleteProject = createAction(
	ProjectActions.DeleteProject,
	props<{ id: number; verificationCode?: string }>()
);

export const deleteProjectSuccess = createAction(
	ProjectActions.DeleteProjectSuccess,
	props<{ id: number }>()
);

export const deleteProjectFail = createAction(ProjectActions.DeleteProjectFail);

export const resetProjectAfterDeletePopupClose = createAction(
	ProjectActions.ResetProject,
	props<{ id: number }>()
);

export const navigateToOrphanProjects = createAction(
	ProjectActions.NavigateToOrphanProjectsRoute
);

export const createNewProject = createAction(
	ProjectActions.NavigateToCreateProjectRoute
);
